/**
 * Shared date-locale helpers for BARE MC i18n.
 * All components should import from here instead of duplicating locale maps.
 */
import { da, enUS, de, es, fr, it, pl } from 'date-fns/locale';

const DATE_FNS_LOCALES = { da, en: enUS, de, es, fr, it, pl };

/**
 * Returns the date-fns locale object for the given language code.
 * Falls back to Danish if the language is not found.
 */
export const getDateFnsLocale = (lang) => DATE_FNS_LOCALES[lang] || da;

/**
 * Returns a BCP 47 locale string for use with Intl / toLocaleDateString.
 * Falls back to 'en-GB' if the language is not supported.
 */
export const getJsLocale = (lang) => {
  const JS_LOCALES = {
    da: 'da-DK',
    en: 'en-GB',
    de: 'de-DE',
    es: 'es-ES',
    fr: 'fr-FR',
    it: 'it-IT',
    pl: 'pl-PL',
  };
  return JS_LOCALES[lang] || 'en-GB';
};
